import React from 'react';
import PropTypes from 'prop-types';
import { Message } from './Message';
import { Loader } from '../../../../../common/elements';

export const MessageList = (props) => {

    const { messages } = props;

    if (!messages) {
        return <Loader />;
    }
    let copyMessages = [...messages];
    let reversedMessages = copyMessages.reverse();

    return (
        <div className="messages-wrapper" style={{height: '300px'}}>
            {
                reversedMessages.map((message, index) => <Message key={index} index={index} message={message} />)
            }
        </div>
    );
};


MessageList.propTypes = {
    messages: PropTypes.array
}


// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/MessageList.js